<template>
  <BasicModal
    :title="'録画面接 削除'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container">
      <h2 class="msg-title">
        {{ recordingInterview.name }}を削除してもよろしいでしょうか？
      </h2>
      <p>
        <b-message type="is-danger" has-icon>
          録画面接内の録画データ、回答データも<br>
          紐づいて削除されますので、よくご確認の上、<br>
          削除をお願い致します。
        </b-message>
      </p>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="deleteRecordingInterview(recordingInterview.id)">削除する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    recordingInterview: {
      type: Object,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false, null)
    },
    deleteRecordingInterview (id) {
      let con = window.confirm('録画面接を削除します。本質問で答えていただいた回答データも紐づいて削除されますがよろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      con = window.confirm('録画面接を削除しますと復元を行うことができませんが本当によろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      this.sendControlLog('録画面接　削除', '録画面接を削除した。')
      this.$emit('delete-recording-interview', id)
      this.cancel()
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 32px;
  h2 {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 16px;
  }
}
.input-field {
  padding: 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoView/organisms/ModalDeleteRecord.vue